import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedInvoicetypeReducer(state = initialState.selectedInvoicetypes, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_INVOICETYPES_SUCCESS:
      return action.selectedInvoicetypes;
    default:
      return state;
  }
}
